const menus = [
  {
    title: 'Home',
    icon: 'mdi-home',
    to: 'Home'
  },
  {
    title: 'Products',
    icon: 'mdi-tshirt-crew',
    to: 'Product'
  },
  {
    title: 'Orders',
    icon: 'mdi-receipt',
    to: 'Order'
  }
]

export default menus
